module.exports = __webpack_public_path__ + "img/logo-neg.deb4033c.svg";